import { estimatePlan, type Plan, type PlanEstimate } from "@roxpacer/core";
import { useMemo } from "react";

export function useEstimate(plan: Plan): PlanEstimate {
  return useMemo(() => estimatePlan(plan), [plan]);
}
